/**
 * Swatch-to-Style Sync for Empire (Wondoflex)
 *
 * Empire renders variant-image swatches server-side, and the Liquid that picks
 * the image walks the variant list and takes the FIRST variant matching the
 * swatch value. On a single-option product (all our yarn) that is always the
 * right variant. On a multi-option product — DMC Eco Vita Bags: Style + Colour —
 * it means every colour swatch shows the photo of that colour in whichever
 * style happens to come first, and nothing updates when the shopper changes
 * style.
 *
 * options-radios.liquid now resolves the correct variant for the FIRST render.
 * This script keeps it correct for every subsequent change:
 *
 *   1. When a non-swatch option changes, repoint each swatch at the variant
 *      matching (this swatch value + the other selected options).
 *   2. Hide swatch values that have no variant at all for the current
 *      combination, and move the selection off a value that just disappeared.
 *
 * No-op on single-option products, so yarn PDPs are untouched.
 */
(function () {
  'use strict';

  var SWATCH_GROUP = '.options-selection__swatches';
  var OPTION_GROUP = '[data-variant-option][data-variant-option-index]';
  var VALUE_WRAPPER = '.options-selection__option-value';

  /**
   * Empire renders swatch images at `x{2 * swatch_size}` with a centre crop,
   * e.g. `…/foo_x128_crop_center.jpg`. Reuse whatever suffix the server already
   * produced so this follows the theme setting rather than hard-coding 128.
   */
  function sizedUrl(src, sampleUrl) {
    if (!src) return null;

    var suffix = '_x128_crop_center';
    var sample = sampleUrl && sampleUrl.match(/_(x\d+|\d+x\d*)_crop_[a-z]+(?=\.[a-z]+(?:\?|$))/i);
    if (sample) suffix = sample[0];

    if (/_(x\d+|\d+x\d*)_crop_[a-z]+\.[a-z]+/i.test(src)) return src;

    return src.replace(/\.(jpe?g|png|webp|gif)(\?|$)/i, suffix + '.$1$2');
  }

  function currentUrlOf(el) {
    var style = el.getAttribute('style') || '';
    var m = style.match(/url\((['"]?)([^'")]+)\1\)/);
    return m ? m[2] : null;
  }

  function init() {
    var dataEl = document.querySelector(
      'script[data-section-type="static-product"][data-section-data]'
    );
    if (!dataEl) return;

    var product;
    try {
      product = JSON.parse(dataEl.textContent).product;
    } catch (e) {
      return;
    }
    if (!product || !product.options || !product.variants) return;

    // Single-option products already render the right swatch image.
    if (product.options.length < 2) return;

    var swatchGroupEl = document.querySelector(SWATCH_GROUP + ' ' + OPTION_GROUP);
    if (!swatchGroupEl) return;

    var swatchIndex = parseInt(swatchGroupEl.getAttribute('data-variant-option-index'), 10);
    if (isNaN(swatchIndex)) return;

    var groups = [].slice.call(document.querySelectorAll(OPTION_GROUP));
    if (groups.length < 2) return;

    var optionKeys = ['option1', 'option2', 'option3'];

    function selectionFor(group) {
      if (group.tagName === 'SELECT') return group.value;
      var checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    /** Current value of every option, indexed by option position. */
    function currentSelections() {
      var out = [];
      groups.forEach(function (group) {
        var i = parseInt(group.getAttribute('data-variant-option-index'), 10);
        if (!isNaN(i)) out[i] = selectionFor(group);
      });
      return out;
    }

    /** Variant matching `swatchValue` on the swatch option and `selections` elsewhere. */
    function variantFor(swatchValue, selections) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v[optionKeys[swatchIndex]] !== swatchValue) continue;

        var matches = true;
        for (var o = 0; o < product.options.length; o++) {
          if (o === swatchIndex) continue;
          // A group we can't read (nothing selected yet) is not a constraint.
          if (selections[o] == null) continue;
          if (v[optionKeys[o]] !== selections[o]) {
            matches = false;
            break;
          }
        }
        if (matches) return v;
      }
      return null;
    }

    var applying = false;

    function apply() {
      if (applying) return;
      applying = true;

      var selections = currentSelections();
      var wrappers = [].slice.call(swatchGroupEl.querySelectorAll(VALUE_WRAPPER));
      var hidCheckedValue = false;

      wrappers.forEach(function (wrapper) {
        var input = wrapper.querySelector('input[type="radio"]');
        if (!input) return;

        var variant = variantFor(input.value, selections);

        if (!variant) {
          // This colour isn't made in the currently selected style.
          wrapper.style.display = 'none';
          wrapper.setAttribute('data-swatch-combination-unavailable', '');
          if (input.checked) hidCheckedValue = true;
          return;
        }

        wrapper.style.display = '';
        wrapper.removeAttribute('data-swatch-combination-unavailable');

        var src = variant.featured_image && variant.featured_image.src;
        if (!src) return;

        var outer = wrapper.querySelector('.options-selection__option-swatch');
        var inner = wrapper.querySelector('.options-selection__option-swatch-inner');
        if (!outer) return;

        var url = sizedUrl(src, currentUrlOf(outer) || (inner && currentUrlOf(inner)));
        if (!url) return;

        outer.style.setProperty('--swatch-image', "url('" + url + "')");
        outer.style.setProperty('--swatch-variant-image', "url('" + url + "')");
        if (inner) inner.style.backgroundImage = "url('" + url + "')";
      });

      applying = false;

      // The selected colour just vanished — move to the first one still offered.
      if (hidCheckedValue) {
        for (var i = 0; i < wrappers.length; i++) {
          if (wrappers[i].hasAttribute('data-swatch-combination-unavailable')) continue;
          var next = wrappers[i].querySelector('input[type="radio"]');
          if (next && !next.checked) {
            next.click();
            break;
          }
        }
      }
    }

    // Any option change can move which variant a swatch should point at.
    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        // Let Empire's own variant handling settle first.
        window.setTimeout(apply, 0);
      });
    });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
